<ng-container *transloco="let t">
<!-- <p>start works!</p>
<ul>
    @for (it of user; track it) {
    <li>{{ it }}</li>
    } @empty {
    <li>There are no user.</li>
    }
</ul> -->
<div *ngIf="step == -1">
    <h6 class="tui-text_h6">
        {{ t('start.whoAreYou') }}
    </h6>
    <img [tuiSkeleton]="skeleton" class="img-text tui-space_top-5 tui-space_bottom-1 skeleton-img" (load)="onImageLoad()" src="{{environment.assertsUrl}}i/start_img.jpg">
    <p class="text tui-space_bottom-3">{{ t('start.testDescription') }}</p>
    <ul class="tui-list tui-list_large">
        <li class="tui-list__item">{{ t('start.testFeatures.dominantEgo') }}</li>
        <li class="tui-list__item">{{ t('start.testFeatures.influence') }}</li>
        <li class="tui-list__item">{{ t('start.testFeatures.improvement') }}</li>
    </ul>
    <div class="btn-start-block">
        <button size="l" appearance="primary" tuiAppearanceMode="" tuiButton type="button"
            class="tui-space_bottom-4 tui-space_top-5" (click)="startTest()">{{ t('start.readyButton') }}</button>
    </div>
</div>
<form *ngIf="!testCompleted && step > -1">
    <div *ngFor="let question of questions; let i = index">
        <div *ngIf="i == step">
            <h1 class="tui-space_bottom-4">{{ t('start.question') }} {{i+1}} / {{questions.length}}</h1>
            <img [tuiSkeleton]="questions[i].skeleton" class="img-text tui-space_top-5 tui-space_bottom-1 skeleton-img" (load)="onImageLoad(i)" src="{{environment.assertsUrl}}{{questions[i].image}}">
            <p class="tui-space_bottom-5 tui-space_top-3 tui-text_body-xl question-blk">{{ t(question.text) }}</p>       
                <div tuiAppearance="secondary" class="btnsBlk" 
                tuiButtonGroup>
                    <button type="button" *ngFor="let score of answerTypes"  (click)="answer(i, score.count)">
                        <tui-icon [icon]="score.img" />
                        {{ score.title }}
                    </button>
                </div>
                
        </div> 
    </div>
</form>



<div *ngIf="testCompleted">
    <h3 class="tui-text_h3 tui-space_bottom-5">{{ t('start.results.title') }}</h3>
    <div class="wrapper">
        <tui-ring-chart [value]="value" [(activeItemIndex)]="activeItemIndex">
            <span>{{ resultTest.name }}</span>
            <div>{{ resultTest.percent}} %</div>
        </tui-ring-chart>
    
        <div class="legend">
            <tui-legend-item *ngFor="let label of labels; let index = index" size="s" class="item"
                [active]="isItemActive(index)" [color]="'var(--tui-chart-categorical-0' + index + ')'" [text]="label"
                (tuiHoveredChange)="onHover(index, $event)">
                <span>
                    {{ value[index] || 0 }} %
                    <!-- <tui-icon style.font-size.px="7" icon="@tui.apple" /> -->
                </span>
            </tui-legend-item>
        </div>
    </div>
   

    <!-- <p class="text tui-space_bottom-3 tui-space_top-5">После прохождения теста и анализа результатов по трем эго-состояниям (Родитель, Взрослый, Ребенок) важно
        понять, как это влияет на вашу жизнь. Ниже представлена подробная расшифровка и практические рекомендации
        для каждого типа доминирующего эго-состояния.</p> -->

    <span [ngSwitch]="resultTest.key">
        <div *ngSwitchCase="categoryPerson.Parent.key">
            <!-- <img class="img-text tui-space_top-5 tui-space_bottom-5" src="{{environment.assertsUrl}}i/start_img.jpg"> -->
            <h5 class="tui-text_h5 tui-space_bottom-5 tui-space_top-5">{{ t('start.results.parentDominant') }}</h5>
            <h6 class="tui-text_h6 tui-space_top-5 tui-space_bottom-6">{{ t('start.results.traits') }}</h6>
            <ul class="tui-list tui-list_large">
                <li class="tui-list__item" *ngFor="let trait of t('start.results.parentTraits')">{{ trait }}</li>
            </ul>
            <h6 class="tui-text_h6 tui-space_top-5 tui-space_bottom-6">{{ t('start.results.problems') }}</h6>
            <ul class="tui-list tui-list_large">
                <li class="tui-list__item" *ngFor="let problem of t('start.results.parentProblems')">{{ problem }}</li>
            </ul>
            <h6 class="tui-text_h6 tui-space_top-5 tui-space_bottom-6">{{ t('start.results.recommendations') }}</h6>
            <ul class="tui-list tui-list_large">
                <li class="tui-list__item" *ngFor="let recommendation of t('start.results.parentRecommendations')">{{ recommendation }}</li>
            </ul>
        </div>
        <div *ngSwitchCase="categoryPerson.Adult.key">
            <!-- <img class="img-text tui-space_top-5 tui-space_bottom-5" src="{{environment.assertsUrl}}i/start_img.jpg"> -->
            <h5 class="tui-text_h5 tui-space_bottom-5 tui-space_top-5">{{ t('start.results.adultDominant') }}</h5>
            <h6 class="tui-text_h6 tui-space_top-5 tui-space_bottom-6">{{ t('start.results.traits') }}</h6>
            <ul class="tui-list tui-list_large">
                <li class="tui-list__item" *ngFor="let trait of t('start.results.adultTraits')">{{ trait }}</li>
            </ul>
            <h6 class="tui-text_h6 tui-space_top-5 tui-space_bottom-6">{{ t('start.results.problems') }}</h6>
            <ul class="tui-list tui-list_large">
                <li class="tui-list__item" *ngFor="let problem of t('start.results.adultProblems')">{{ problem }}</li>
            </ul>
            <h6 class="tui-text_h6 tui-space_top-5 tui-space_bottom-6">{{ t('start.results.recommendations') }}</h6>
            <ul class="tui-list tui-list_large">
                <li class="tui-list__item" *ngFor="let recommendation of t('start.results.adultRecommendations')">{{ recommendation }}</li>
            </ul>
        </div>
        <div *ngSwitchCase="categoryPerson.Child.key">
            <!-- <img class="img-text tui-space_top-5 tui-space_bottom-5" src="{{environment.assertsUrl}}i/start_img.jpg"> -->
            <h5 class="tui-text_h5 tui-space_bottom-5 tui-space_top-5">{{ t('start.results.childDominant') }}</h5>
            <h6 class="tui-text_h6 tui-space_top-5 tui-space_bottom-6">{{ t('start.results.traits') }}</h6>
            <ul class="tui-list tui-list_large">
                <li class="tui-list__item" *ngFor="let trait of t('start.results.childTraits')">{{ trait }}</li>
            </ul>
            <h6 class="tui-text_h6 tui-space_top-5 tui-space_bottom-6">{{ t('start.results.problems') }}</h6>
            <ul class="tui-list tui-list_large">
                <li class="tui-list__item" *ngFor="let problem of t('start.results.childProblems')">{{ problem }}</li>
            </ul>
            <h6 class="tui-text_h6 tui-space_top-5 tui-space_bottom-6">{{ t('start.results.recommendations') }}</h6>
            <ul class="tui-list tui-list_large">
                <li class="tui-list__item" *ngFor="let recommendation of t('start.results.childRecommendations')">{{ recommendation }}</li>
            </ul>
        </div>
        <div *ngSwitchDefault>
           
        </div>
    </span>

    <h5 class="tui-text_h5 tui-space_top-5 tui-space_bottom-3">{{ t('start.idealBalance.title') }}</h5>
    <p class="text tui-space_bottom-3">{{ t('start.idealBalance.description') }}</p>
    <ul class="tui-list tui-list_large">
        <li class="tui-list__item"><strong>{{ t('start.idealBalance.adult') }}</strong></li>
        <li class="tui-list__item"><strong>{{ t('start.idealBalance.parent') }}</strong></li>
        <li class="tui-list__item"><strong>{{ t('start.idealBalance.child') }}</strong></li>
    </ul>

    <div class="btn-start-block">
        <button size="l" appearance="primary" tuiAppearanceMode="" (click)="shareResult()" tuiButton type="button"
            class="tui-space_bottom-3 tui-space_top-6" >{{ t('start.actions.shareWithFriends') }}</button>
        <!-- Иконки соцсетей -->
        <!-- <div class="social-share">
            <a [href]="getFacebookShareUrl()" target="_blank"><tui-icon icon="@tui.facebook" /></a>
            <a [href]="getTwitterShareUrl()" target="_blank"><tui-icon icon="@tui.twitter" /></a>
            <a [href]="getTelegramShareUrl()" target="_blank"><tui-icon icon="@tui.telegram" /></a>
            <a [href]="getWhatsAppShareUrl()" target="_blank"><tui-icon icon="@tui.whatsapp" /></a>
        </div> -->
        <button size="l" appearance="outline" tuiAppearanceMode="" tuiButton type="button"
            class="tui-space_bottom-4 tui-space_top-2" (click)="router.navigate([ROUTES_CONST.TRAINING])">{{ t('start.actions.learnEgoStates') }}</button>
        <button size="l" appearance="flat" tuiAppearanceMode="" tuiButton type="button"
            class="tui-space_bottom-4 tui-space_top-2" (click)="reloadTest()">{{ t('start.actions.retakeTest') }}</button>
    </div>

</div>
</ng-container>

